var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-venue-listpreview"},[(_vm.venueCollection.length > 0)?_c('ViewVenueList',{attrs:{"venueCollection":_vm.venueCollection},on:{"select":_vm.Handle_OnClickVenue}}):(_vm.emptyState === 'no-favorites')?_c('ViewUiStateNoFavorites'):(_vm.emptyState === 'loading')?_c('ViewUiStateLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }